var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentHistoryEmptyState = function SvgPaymentHistoryEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 142,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M192.626 59.168c0 49.935-38.762 102.542-90.766 58.077C49.855 72.779 1.318 109.103 1.318 59.168S43.206-6.074 79.467 21.79c36.261 27.865 113.159-12.558 113.159 37.377Z",
    fill: props.accentFill
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.197 47V30h111.549v17H41.197Zm-5 0V28a3 3 0 0 1 3-3h115.549a3 3 0 0 1 3 3v83a3 3 0 0 1-3 3H39.197a3 3 0 0 1-3-3V47Zm116.549 5H41.197v57h111.549V52Z",
    fill: "#363840"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.09,
    y: 63.5,
    width: 32.822,
    height: 10,
    rx: 4.5,
    fill: "#363840",
    stroke: "#363840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#363840",
    d: "M48.551 35.14h6.342v6h-6.342zM139.609 35.14h6.342v6h-6.342z"
  })));
};
export default SvgPaymentHistoryEmptyState;